import _ from 'lodash';
import { getFirstKTokens, getTokenCount } from './tokenTools';
import { TEMP_NUMBER } from '../constants/nlpSettings';

/**
 * Get total number of tokens in an array of messages that we send to ChatGPT.
 */
const getConversationTokenCount = (messages) => (
  _.reduce(messages, (sum, message) => sum + getTokenCount(message.content), 0)
);

/**
 * Trims a conversation so that the whole thing is less than the token limit.
 * Conversations typically start with a system message that tells ChatGPT
 * what to do, followed by messages from the user and ChatGPT. This function
 * always keeps the system message and the most recent user message, but it
 * will remove the other messages oldest-first. However, the last 5 historical
 * messages will be kept. It will also trim the system message if it needs to.
 */
const trimConversationToFitTokenLimit = (messages, nlpConstants, isBrochure) => {
  const MAX_TOKEN_COUNT = nlpConstants
    ? parseInt(nlpConstants.MAX_TOKEN_COUNT.value, 10) : TEMP_NUMBER;
  const MIN_NUM_HISTORICAL_MESSAGES = nlpConstants
    ? parseInt(nlpConstants.MIN_NUM_HISTORICAL_MESSAGES.value, 10) : TEMP_NUMBER;

  const newMessages = _.cloneDeep(messages);
  while (true) {
    const tokenCount = getConversationTokenCount(newMessages);
    if (tokenCount <= MAX_TOKEN_COUNT || isBrochure) break;

    // If the conversation is just one message, trim that message
    if (newMessages.length === 1) {
      newMessages[0].content = getFirstKTokens(newMessages[0].content, MAX_TOKEN_COUNT);
      break;
    }

    /* 1. If there's no system message, keep deleting the earliest non-system message
     * until the token count is less than the limit.
     * 2. If there's system message, try to delete the earliest non-system message until
     * there are only N. Then, we trim the system message to the target token count,
     * because we want to keep at least N historical conversations */
    if (newMessages[0].role === 'system') {
      // +2 for system message and new user message
      if (newMessages.length > MIN_NUM_HISTORICAL_MESSAGES + 2) {
        // Delete the earliest non-system message
        newMessages.splice(1, 1);
      } else {
        // Trim the system message
        const systemMessageTokenCount = getTokenCount(newMessages[0].content);
        const tokenExceeded = tokenCount - MAX_TOKEN_COUNT;
        const newSystemMessage = getFirstKTokens(newMessages[0].content,
          systemMessageTokenCount - tokenExceeded);
        newMessages[0].content = newSystemMessage;
        break;
      }
    } else {
      // Delete the earliest message
      newMessages.splice(0, 1);
    }
  }
  return newMessages;
};

export default trimConversationToFitTokenLimit;
